import { type Stacklet } from '@/entities/stacklet';
import request from '@/shared/api/request';

export const resizeStacklet = (
  id: number,
  data: { disk: boolean; size: string },
): Promise<{ stacklet: Stacklet }> =>
  request({
    url: `/stacklets/${id}/`,
    method: 'POST',
    data: { action: 'resize', ...data },
  });
